import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {GameFeatureMode} from "../enums/Enum";
import {GameUtils} from "../utils/GameUtils";
import {SymbolContainer} from "../reels/SymbolContainer";
import {XMentalSymbol} from "../reels/XMentalSymbol";
import {Sound} from "../sound/Sound";

export class XMentalIntroRunner implements SimplePresentation {
    shouldRun(): boolean {
        return Game.model.isXMentalActive() && (Game.model.data.mode === GameFeatureMode.NORMAL && Game.model.data.nextMode === GameFeatureMode.RESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        const xMentalSymContainer: SymbolContainer = GameUtils.getSymbol(Game.model.xMentalPos.x, Game.model.xMentalPos.y);
        const xMentalBigSymbolEffect: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("xMentalBigSymbolEffect"));
        xMentalBigSymbolEffect.position.set(361, 414);
        xMentalBigSymbolEffect.alpha = 0;
        Game.effectsView.addChild(xMentalBigSymbolEffect);
        tl.add([
            //(xMentalSymContainer.symbols[0] as XMentalSymbol).playTrigger(xMentalSymContainer.isTopHalf),
            gsap.to(xMentalBigSymbolEffect, {alpha: 1, duration: 0.001}),
            () => {
                Game.blackBG.show(0.8);
                (xMentalSymContainer.symbols[0] as XMentalSymbol).stopLoop();
                Game.soundPlayer.playSound(Sound.X_MENTAL_BIG_ANIMATION);
                Game.soundPlayer.fadeSound(1, 0, 2000);
            },
            GameUtils.createTimelineForAnimation(xMentalBigSymbolEffect, 0, "animation", false)
        ]);
        // tl.add(GameUtils.createTimelineForAnimation(xMentalBigSymbolEffect, 0, "animation", false));
        // tl.add(GameUtils.createTimelineForAnimation(xMentalBigSymbolEffect, 0, "animation", false).timeScale(2));
        tl.add(Game.backgroundElements.glitchMainToReSpin(), 0.18);

        // tl.to(xMentalBigSymbolEffect, {alpha: 1, duration: 0.1});
        tl.add(Game.blackBG.hide(0.2), "-=0.2");

        tl.add(() => {
            Game.soundPlayer.playSound(Sound.X_MENTAL_SPIN_LOOP, 1, Number.MAX_VALUE);

            xMentalBigSymbolEffect.parent?.removeChild(xMentalBigSymbolEffect);
            this.closedCallback(controller);
        });
    }

    private closedCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

}